import { Col, Row, Image, Button } from 'antd'
import styled from 'styled-components'
import ViewContainer from './container'

const Styled = styled.div`
  height: 116px;
  cursor: pointer;
  margin-top: 2rem;
  border-radius: 10px;
  position: relative;

  .ant-row {
    padding: 0px 39px 0px 39px;
    .sp-card {
      display: flex;
      justify-content: flex-end;
      flex-direction: column;

      .ant-image {
        width: 100%;
        min-width: 158px;
      }
    }
    .details {
      display: flex;
      justify-content: center;
      flex-direction: column;
      .highlighted {
        color: #fed312;
      }
      h1 {
        font-size: 41px;
      }
    }

    .btn {
      display: flex;
      justify-content: center;
      flex-direction: column;
      span {
        font-weight: normal;
      }
    }
  }

  @media (max-width: 576px) {
    .details {
      h1 {
        font-size: 18px !important;
        line-height: 21px;
      }
    }
  }

  @media (max-width: 767px) {
      .btn {
      display: none !important;
    }
  }

  @media (max-width: 768px) {
    height: 73px;
    .ant-row {
      padding: 0px 0px 0px 12px;
      border-radius: 8px;
      background-size: cover !important;

      .sp-card {
        height: 100%;
        width: 100%;
        .ant-image {
          width: 100%;
        }
        .ant-image-img {
          max-width: 118px !important;
        }
      }

      .details {
        h1 {
          font-size: 26px;
          line-height: 21px;
        }
      }
    }
  }
`

export default function Index() {
  return (
    <ViewContainer>
      {({ handleKnowMore, loading }) => (
        <Styled onClick={handleKnowMore}>
          <Row
            style={{
              backgroundImage:
                "url('/images/supercard_v2/sc-banner-bg-v2.png')",
              backgroundColor: '#3B3B3B',
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
              height: '100%',
              borderRadius: 10
            }}
          >
            <Col className='sp-card' span={4}>
              <Image
                preview={false}
                src='/images/supercard_v2/sc-banner-v2.png'
              />
            </Col>
            <Col
              className='details'
              xs={{ span: 14, offset: 5 }}
              md={{ span: 11, offset: 2 }}
              lg={{ span: 14, offset: 2 }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 4,
                  flexWrap: 'wrap'
                }}
              >
                <h1 style={{ color: 'white', lineHeight: 'normal' }}>
                  Your Supercard made more Super!
                </h1>
              </div>
            </Col>
            <Col
              className='btn'
              xs={{ span: 0, offset: 0 }}
              md={{ span: 5, offset: 1 }}
              lg={{ span: 4, offset: 0 }}
            >
              <Button
                style={{ borderColor: 'var(--orange-peel)', width: '100%' }}
                disabled={loading}
                onClick={handleKnowMore}
                type='default'
                ghost
              >
                Know More
              </Button>
            </Col>
          </Row>
        </Styled>
      )}
    </ViewContainer>
  )
}
